export interface ValidationProvider {
  validationSeverity: ValidationSeverity;
  validationMessage: string;
}

export type ValidationSeverity = 'info' | 'warning' | 'error';
export const validationSeverities = ['info', 'warning', 'error'] as const;
